import { render, staticRenderFns } from "./tradeActivityList.vue?vue&type=template&id=3666a48a&scoped=true"
import script from "./tradeActivityList.vue?vue&type=script&lang=js"
export * from "./tradeActivityList.vue?vue&type=script&lang=js"
import style0 from "./tradeActivityList.vue?vue&type=style&index=0&id=3666a48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3666a48a",
  null
  
)

export default component.exports